import { useCallback } from "react"
import { useRecoilValue } from "recoil"
import { Views } from "../../constants"
import { ToastConfigProps, useCustomToast } from "../useToast"
import { viewCallbackSelector } from "../../recoil/atoms/view"

const useCameraAccessFailedToast = () => {
  const config: ToastConfigProps = {
    toastOptions: {
      containerStyle: {
        margin: "0.1rem"
      }
    },
    titleStyles: {
      fontWeight: 700
    }
  }
  const showTopToastMessage = useCustomToast({ ...config, position: "top" })
  const showBottomToastMessage = useCustomToast({
    ...config,
    position: "bottom-right"
  })
  const viewCallback = useRecoilValue(viewCallbackSelector)

  const showCameraAccessFailedToast = useCallback(async () => {
    const currentView = await viewCallback.getCurrentView()
    let showToast = null
    if (currentView === Views.HOME) {
      showToast = showTopToastMessage
    } else if (currentView === Views.MEETING_ROOM) {
      showToast = showBottomToastMessage
    }

    if (showToast) {
      showToast(
        "Cannot access failed",
        "Your camera is being used by another application"
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return showCameraAccessFailedToast
}

export default useCameraAccessFailedToast
